var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-table"},[_c('Table',{attrs:{"border":"","columns":_vm.columns1,"data":_vm.tableData,"span-method":_vm.spanMethod},scopedSlots:_vm._u([{key:"checkVisit",fn:function({ row }){return [_c('span',{domProps:{"innerHTML":_vm._s(row.checkVisit)}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }